var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50391 0.841797C6.65039 1.33984 6.38672 1.83789 5.88867 1.98438C3.54492 2.6875 1.875 4.85547 1.875 7.375C1.875 10.4805 4.36523 13 7.5 13C10.6055 13 13.125 10.4805 13.125 7.375C13.125 4.85547 11.4258 2.6875 9.08203 1.98438C8.58398 1.83789 8.32031 1.33984 8.4668 0.841797C8.61328 0.34375 9.14062 0.0507812 9.63867 0.197266C12.7148 1.13477 15 3.97656 15 7.375C15 11.5352 11.6309 14.875 7.5 14.875C3.33984 14.875 0 11.5352 0 7.375C0 3.97656 2.25586 1.13477 5.33203 0.197266C5.83008 0.0507812 6.35742 0.34375 6.50391 0.841797Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/LoadingIcon.7cbb7118e601793037c1976b634f5941.svg";
export { ForwardRef as ReactComponent };